<script setup lang="ts">
import { computed } from 'vue';

import { PoolNote } from '@/types/untangled/pool';
import { configService } from '@/services/config/config.service';

/**
 * TYPES
 */
type Props = {
  poolNote: PoolNote;
};

/**
 * PROPS & EMITS
 */
const props = defineProps<Props>();

/** COMPUTED */
const poolChainName = computed(() => {
  const chainId = props?.poolNote?.pool?.chainId;
  const chainName = configService.getNetworkConfig(chainId)?.chainName;
  return chainName;
});
</script>

<template>
  <div class="flex gap-4 items-center py-4 px-6">
    <span class="text-right"> {{ poolNote?.pool?.name }} </span>
    <span
      v-if="poolChainName"
      class="justify-center py-1 px-2 w-auto text-xs text-gray-600 border border-gray-600 rounded-[36px]"
    >
      {{ poolChainName }}
    </span>
  </div>
</template>
